export default {

  // COMMON
  BG_COLOR: '#f3f3f3', // merchants grey
  MAIN_COLOR: '#454546', // MERCHANTS GREY
  MAIN_INVERTED_COLOR: '#ffffff', // white
  PRIMARY_COLOR: '#AA1E2D', // MERCHANTS RED
  SECONDARY_COLOR: '#434244', // merchants dark grey
  DESCRIPTION_COLOR: '#9FB2BE',
  ATTENTION_COLOR: '#dc3545', // red
  SUCCESS_COLOR: '#40b844', // green
  WARNING_COLOR: '#ffc107', // orange

  // OTHER
  TRANSPARENT: 'transparent'

}
